class HandledError {
  constructor(value) {
    this.value = value;
  }

}

export { HandledError };
//# sourceMappingURL=HandledError.js.map
